import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Rate,
  Row,
  Select,
  Skeleton,
} from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { Editor } from "react-draft-wysiwyg";
import {
  convertToRaw,
  EditorState,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { getCategories } from "../../actions/categories";
import { useDispatch, useSelector } from "react-redux";
import draftToHtml from "draftjs-to-html";
import {
  createProduct,
  deleteProduct,
  getProduct,
  updateProduct,
  updateProductGallery,
  deleteImage,
} from "../../actions/products";
import { useNavigate, useParams } from "react-router-dom";

const Product = ({ currentUser, storeCurrency }) => {
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [rating, setRating] = useState(4);
  const [isFeatured, setIsFeatured] = useState(true);
  const [, forceUpdate] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [file, setFile] = useState("");
  const categoriesList = useSelector((state) => state.categories);
  const { id } = useParams();
  const product = useSelector((state) => state.products);
  const [fileList, setFileList] = useState([]);
  const [loadingBtnGallery, setLoadingBtnGallery] = useState(false);
  const [newFileList, setNewFileList] = useState([]);

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    forceUpdate({});
    dispatch(getCategories(currentUser.store));
    if (id) {
      dispatch(getProduct(id));
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const dispatch = useDispatch();
  const history = useNavigate();
  const { Option } = Select;
  const [form] = Form.useForm();

  const onFinish = (value) => {
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const markup = draftToHtml(rawContentState);
    const productData = {
      ...value,
      description: markup,
      rating,
      isFeatured,
      image: file,
      user: currentUser.id,
      store: currentUser.store,
    };
    setLoadingButton(true);
    let formData = new FormData();
    formData.append("image", productData?.image);
    formData.append("name", productData?.name);
    formData.append("brand", productData?.brand);
    formData.append("price", productData?.price);
    formData.append("description", productData?.description);
    formData.append("category", productData?.category);
    formData.append("countInStock", productData?.countInStock);
    formData.append("rating", productData?.rating);
    formData.append("isFeatured", productData?.isFeatured);
    formData.append("sku", productData?.sku);
    formData.append("user", productData?.user);
    formData.append("store", productData?.store);

    if (id) {
      dispatch(updateProduct(id, formData, history, setLoadingButton));
    } else {
      dispatch(createProduct(formData, history, setLoadingButton));
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      name: product?.name,
      countInStock: product?.countInStock,
      price: product?.price,
      brand: product?.brand,
      category: product?.category?._id,
      sku: product?.sku,
    });
    setRating(product?.rating);
    setIsFeatured(product?.isFeatured);
    setFileList(product?.images);
    setEditorState(
      EditorState?.createWithContent(
        ContentState?.createFromBlockArray(
          convertFromHTML(product?.description ? product?.description : "")
        )
      )
    );
  }, [product]);

  const uploadGallery = () => {
    setLoadingBtnGallery(true);
    let formData = new FormData();
    if (newFileList?.length > 0) {
      //add the more files
      Object.keys(newFileList).forEach((key) => {
        if (key === "images") {
          let images = Array.from(newFileList?.images[0]);
          for (let i = 0; i < images.length; i++) {
            formData.append("images", images[i]);
          }
        } else {
          formData.append("images", newFileList[key]);
        }
      });

      dispatch(
        updateProductGallery(id, formData, history, setLoadingBtnGallery)
      );
    } else {
      //first time file uplaod
      Object.keys(fileList).forEach((key) => {
        if (key === "images") {
          let images = Array.from(fileList?.images[0]);
          for (let i = 0; i < images.length; i++) {
            formData.append("images", images[i]);
          }
        } else {
          formData.append("images", fileList[key]);
        }
      });
      dispatch(
        updateProductGallery(id, formData, history, setLoadingBtnGallery)
      );
    }
  };

  const handleFiles = (event) => {
    if (!newFileList?.length > 0) {
      setNewFileList(event?.target?.files);
    } else {
      setFileList(event?.target?.files);
    }
  };

  const deleteProductFun = () => {
    dispatch(deleteProduct(id, history));
  };

  const deleteImageFun = (url) => {
    const imageName = url.split("/").pop();
    dispatch(deleteImage(id, imageName, history));
  };

  return (
    <Dashboard title={`${id ? "View" : "Add"} Product`}>
      <div className="p-4 shadow bg-white mt-2 mb-6 flex items-center justify-between">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/products">Products</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{`${id ? "View" : "Add"} Product`}</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        form={form}
        autoComplete="off"
      >
        <div className="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div className="mt-5 md:mt-0 md:col-span-2 px-4 py-5 sm:p-6 bg-white shadow">
            <Skeleton loading={loading}>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    label="Title"
                    name="name"
                    rules={[
                      { required: true, message: "Please input product name!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <label className="pb-2">Description</label>
                <Col span={24}>
                  <div
                    style={{
                      border: "1px solid #d9d9d9",
                      padding: 10,
                    }}
                  >
                    <Editor
                      editorState={editorState}
                      onEditorStateChange={setEditorState}
                    />
                  </div>
                </Col>
                {id ? (
                  <Col span={24} className="mt-4">
                    <label>Gallery</label>
                    <input
                      type="file"
                      className="my-3"
                      multiple
                      onChange={(event) => handleFiles(event)}
                    />
                    <div className="grid grid-cols-4 gap-4">
                      {fileList?.length > 0 &&
                        [...fileList]?.map((file, index) => (
                          <div
                            className="w-full preview-image preview-image-100"
                            key={index}
                          >
                            <div className="preview-icons">
                              <DeleteOutlined
                                className="cursor-pointer text-lg"
                                onClick={() => deleteImageFun(file)}
                              />
                            </div>
                            <img
                              src={file ? file : URL.createObjectURL(file)}
                              alt="Preview"
                              className="gallery"
                            />
                          </div>
                        ))}
                      {newFileList?.length > 0 &&
                        [...newFileList]?.map((file, index) => (
                          <div
                            className="w-full preview-image preview-image-100"
                            key={index}
                          >
                            <img
                              src={URL.createObjectURL(file)}
                              alt="Preview"
                              className="gallery"
                            />
                          </div>
                        ))}
                    </div>
                    {newFileList?.length > 0 ? (
                      <Button
                        type="primary"
                        className="mt-4"
                        onClick={uploadGallery}
                        loading={loadingBtnGallery}
                      >
                        Update Gallery
                      </Button>
                    ) : (
                      ""
                    )}
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            </Skeleton>
          </div>
          <div className="md:col-span-1">
            <div className="bg-white shadow px-4 py-5 sm:p-6">
              <Skeleton loading={loading}>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label="Category" name="category">
                      <Select
                        style={{ width: "100%" }}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {categoriesList?.map((category) => (
                          <Option key={category?._id} value={category?._id}>
                            {category?.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Brand/Vendor" name="brand">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Price"
                      name="price"
                      rules={[
                        {
                          required: true,
                          message: "Please input product price!",
                        },
                      ]}
                    >
                      <Input prefix={storeCurrency} type="number" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Stock"
                      name="countInStock"
                      rules={[
                        { required: true, message: "Please input stock!" },
                      ]}
                    >
                      <InputNumber
                        min="0"
                        max="100"
                        type="number"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="SKU"
                      name="sku"
                      rules={[{ required: true, message: "Please input sku!" }]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Checkbox
                      isFeatured={isFeatured}
                      defaultChecked
                      onChange={(e) => setIsFeatured(e.target.checked)}
                    >
                      This is a featured product
                    </Checkbox>
                  </Col>
                  <Col span={24} className="py-4">
                    <label className="mr-2">Rating</label>
                    <Rate
                      defaultValue={rating}
                      onChange={(e) => setRating(e)}
                    />
                  </Col>
                  <Col span={24} className="my-2 overflow-hidden">
                    <label>Featured Image</label>
                    {id ? (
                      <div className="my-4 border preview-image preview-image-100">
                        <div className="preview-icons">
                          <div className="image-upload">
                            <EditOutlined className="cursor-pointer text-lg" />
                            <input
                              type="file"
                              className="mb-2"
                              onChange={(event) =>
                                setFile(event.target.files[0])
                              }
                            />
                          </div>
                          {/* <DeleteOutlined className="cursor-pointer text-lg" /> */}
                        </div>
                        <img
                          src={
                            file ? URL.createObjectURL(file) : product?.image
                          }
                          alt="Preview"
                          className="large-img"
                        />
                      </div>
                    ) : file === "" ? (
                      <input
                        type="file"
                        className="my-2"
                        onChange={(event) => setFile(event?.target?.files[0])}
                      />
                    ) : (
                      <div className="my-4 border preview-image preview-image-100">
                        <div className="preview-icons">
                          <div className="image-upload">
                            <DeleteOutlined
                              className="cursor-pointer text-lg"
                              onClick={() => setFile("")}
                            />
                          </div>
                        </div>
                        <img
                          src={
                            file ? URL.createObjectURL(file) : product?.image
                          }
                          alt="Preview"
                          className="large-img"
                        />
                      </div>
                    )}

                    <Modal
                      open={previewVisible}
                      footer={null}
                      onCancel={() => setPreviewVisible(false)}
                    >
                      <img
                        alt="example"
                        className="w-full"
                        src={file ? URL.createObjectURL(file) : ""}
                      />
                    </Modal>
                  </Col>
                  <Col span={24}>
                    <div className="flex flex-wrap  justify-start gap-4">
                      <Button href="/products">Cancel</Button>
                      <Form.Item shouldUpdate style={{ marginBottom: 0 }}>
                        {() => (
                          <Button
                            type="primary"
                            htmlType="submit"
                            disabled={
                              (!id && !form.isFieldsTouched(true)) ||
                              !!form
                                .getFieldsError()
                                .filter(({ errors }) => errors.length).length
                            }
                            loading={loadingButton}
                          >
                            {`${id ? "Update" : "Save"} Product`}
                          </Button>
                        )}
                      </Form.Item>
                      {id ? (
                        <Popconfirm
                          title="Are you sure to delete this product?"
                          onConfirm={deleteProductFun}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button danger type="primary">
                            Delete
                          </Button>
                        </Popconfirm>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
              </Skeleton>
            </div>
          </div>
        </div>
      </Form>
    </Dashboard>
  );
};

export default Product;
